import {ReactElement} from 'react';

import {Stack,} from '@mantine/core';

import {useExecutions} from '../hooks/useExecutions.ts';

import {MantineDataTable,} from '@flexinet/ui-components';
import {DataTableColumn} from "mantine-datatable";

export const ExecutionsTable = ({
                                    extraTools: _extraTools,
                                    settings: _settings,
                                }: {
    extraTools?: ReactElement[],
    settings?: { label: string, onClick: () => void }[]
} = {}) => {

    const {
        columns,
        visibleItems: records,
        loading,
    } = useExecutions();

    return (
        <Stack>
            <MantineDataTable
                columns={columns as DataTableColumn[]}
                records={records}
                fetching={loading}
            />
        </Stack>
    );
};
